'use client'

import GeneralForm from "components/GeneralForm";
import TitleFormWithEdit from "components/TitleFormWithEdit";
import { validate } from "components/validateGeneralForm";
import { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Button, Card, CardBody, Container } from "reactstrap";
import { erroInesperado } from "services/Utils";
import tipoAnexoCruzamentoService from "services/TipoAnexoCruzamentoService";

export default function FormTipoAnexoCruzamento() {
  const [data, setData] = useState({})
  const [edit, setEdit] = useState(false)
  const params = useParams()
  const navigate = useNavigate()

  const id = parseInt(params.id)
  const novo = (0 === id)

  useEffect(() => {
    if (!!id) {
      tipoAnexoCruzamentoService.getById(id).then(res => {
        if (res.success) {
          setData(res.data)
        }
      })
    } else {
      setData({})
    }
  }, [id])

  useEffect(() => {
    if (novo) {
      setEdit(true)
    }
  }, [novo])

  const formConfig = useMemo(() => {
    return [
      [
        { name: "descricao", label: 'Descrição', type: "text", required: true, colspan: 12 },
      ]
    ]
  }, [data])

  const handleChange = (name, value) => {
    setData({ ...data, [name]: value })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    const errors = validate(formConfig, data)
    if (errors.length > 0) {
      setData({ ...data, errors })
      return
    }

    try {
      if (novo) {
        await tipoAnexoCruzamentoService.create(data)
      } else {
        await tipoAnexoCruzamentoService.update(id, data)
      }
      toast('Registro salvo com sucesso!')
      navigate('/admin/tipos-anexo-cruzamento')
    } catch (ex) {
      erroInesperado()
    }

  }

  return (
    <Container fluid>
      <TitleFormWithEdit title="Tipo de Anexo do Cruzamento" edit={edit} onChangeEdit={setEdit} showButton={!novo} />
      <Card>
        <CardBody>
          <form onSubmit={handleSubmit}>
            <GeneralForm
              config={formConfig}
              data={data}
              onChange={handleChange}
              disabled={!edit}
            />
            {edit && (
              <Button type="submit" color="primary">Salvar</Button>
            )}
          </form>
        </CardBody>
      </Card>
    </Container>
  )
}
